export const tr = {
  odaPlani: 'Oda planı',
  raporlar: 'Raporlar',
  kbsDurum: 'KBS durum',
  checkIn: 'Check-in',
  housekeeping: 'Kat hizmetleri',
  cikisYap: 'Çıkış yap',
  giris: 'Giriş',
  eposta: 'E-posta',
  sifre: 'Şifre',
  girisYap: 'Giriş yap',
  cevrimdisi: 'Çevrimdışı — işlemler kaydediliyor',
  bekleyenIslem: 'bekleyen işlem',
  // --- misafir mobil (odadaki QR)
  hosGeldiniz: 'Hoş geldiniz',
  oda: 'Oda',
  cikis: 'Çıkış',
  neLazim: 'Ne lazım?',
  taleplerim: 'Taleplerim',
  anaEkran: 'Ana ekran',
  canli: 'Canlı',
  talepYok: 'Henüz talep yok',
  talepYokAciklama: 'Ana ekrandan bir talep açın; burada canlı olarak izleyin.',
  alindi: 'Alındı',
  tamamlandi: 'Tamamlandı',
  iptalEdildi: 'İptal edildi',
  nasildi: 'Nasıldı?',
  kopyala: 'Kopyala',
  kopyalandi: 'Kopyalandı',
  resepsiyonaYaz: 'Resepsiyona yaz',
  talepAnindaDuser: 'Talebiniz anında resepsiyon ve kat hizmetleri ekranına düşer.',
  gonderiliyor: 'Gönderiliyor…',
  vazgec: 'Vazgeç',
  talebiGeriAl: 'Talebi geri al',
  gorevliYolda: 'Görevli yolda · yaklaşık {dk} dk',
  resepsiyonBakiyor: 'Resepsiyon müsaitliğe bakıyor.',
  linkKapali: 'Bu sayfa artık açık değil',
  linkKapaliAciklama: 'Oda bağlantısı yalnızca konaklama süresince çalışır. Bir isteğiniz varsa resepsiyon size yardımcı olur.',
  tekrarDene: 'Tekrar dene',
  yukleniyor: 'Yükleniyor…',
  baglanilamadi: 'Bağlanılamadı.',
  gonderilemedi: 'Gönderilemedi.',
  talebinizAlindi: 'Talebiniz alındı',
  talebinizZatenAcik: 'Talebiniz zaten açık',
  gecCikisOnayli: 'Geç çıkış onaylandı',
  rahatsizEtmeyinAcik: 'Rahatsız etmeyin açık',
  cevrimdisiKuyrukta: 'Bağlantı yok — talebiniz kaydedildi, bağlantı gelince gönderilecek.',
  kimlikBaslik: 'Odanıza hoş geldiniz',
  kimlikAciklama: 'Devam etmek için kimlik numaranızı girin. Rezervasyonunuzdaki T.C. kimlik ya da pasaport numarası.',
  kimlikNo: 'Kimlik / pasaport no',
  devamEt: 'Devam et',
  dogrulaniyor: 'Kontrol ediliyor…',
  kimlikNeden: 'Bu adım, oda numaranızı bilen başkalarının bilgilerinize ulaşmasını engeller.',
  oturumBitti: 'Oturumunuz sona erdi, kimlik numaranızı tekrar girin.',
} as const;
